export const selectShowCategoryModal = (state:any) => state.service.showCategoryModal;

export const selectShowSubCategoryModal = (state:any) => state.service.showSubCategoryModal;


export const selectServiceList = (state:any) => state.service.serviceList;
export const selectServiceCategoryItem = (state:any) => state.service.selectedCategoryItem;

export const selectServiceSubCategoryItem = (state:any) => state.service.selectedSubCategoryItem;


export const selectServiceLoading = (state:any) => state.service.serviceLoading;

export const selectServiceListLoading = (state:any) => state.service.loading;
